import type { IconName } from '@/components/entities/Sprite/Icon';
import type { ModalNameType } from '@/modals/components/ModalProvider';
import { isFairPlayEnabled } from '@/app/[locale]/(root)/fair-play/availability';
import { AppRoutes } from '@/i18n/constants';

/** The Shop link's badge key: it opens a modal and has no route to key its badge by. */
export const SHOP_BADGE_KEY = 'shop';

export type NavigationLink = {
  label: string;
  icon: IconName;
  href?: string;
  modal?: ModalNameType;
  badge?: string;
  /** Keys a dynamic badge for a link that only opens a modal; links with a route are keyed by it. */
  badgeKey?: typeof SHOP_BADGE_KEY;
  /** Keeps the link active on nested routes, e.g. every `/fair-play/*` page for the Fair Play dashboard link. */
  activePathPrefix?: string;
};

/** Where `useNavigationBadges` keys a link's badge: its own badge key, else its route. */
export const getNavigationBadgeKey = (link: NavigationLink): string | undefined => link.badgeKey ?? link.href;

const FAIR_PLAY_LINK: NavigationLink = {
  label: 'Fair Play',
  icon: 'fairplay',
  href: `${AppRoutes.fairPlay}/dashboard`,
  activePathPrefix: AppRoutes.fairPlay,
  badge: 'Beta',
};

const GAMIFICATION_LINKS: NavigationLink[] = [
  {
    label: 'Missions',
    icon: 'missions',
    href: AppRoutes.gamificationMissions,
  },
  {
    label: 'Rewards',
    icon: 'rewards',
    href: AppRoutes.gamificationRewards,
  },
];

export const PROTECTED_LINKS: NavigationLink[] = [
  {
    label: 'Shop',
    icon: 'purchases',
    modal: 'deposit',
    badgeKey: SHOP_BADGE_KEY,
  },
  {
    label: 'Redeem',
    icon: 'redeem',
    modal: 'redeem',
  },
  ...(GAMIFICATION_LINKS),
  {
    label: 'Promotions',
    modal: 'deposit',
    icon: 'promotion',
  },
  ...(isFairPlayEnabled() ? [FAIR_PLAY_LINK] : []),
  {
    label: 'Invite friends',
    icon: 'invite-friend',
    href: AppRoutes.referral,
  },
];

export const ACCOUNT_LINKS: NavigationLink[] = [

  {
    label: 'Profile',
    href: '/profile',
    icon: 'profile',
  },

  {
    label: 'Customer Support',
    modal: 'support',
    icon: 'support-navbar',
  },
];
